import { gql } from "@apollo/client";

export const CREATE_CF_ROLE = gql`
  mutation CreateCfRole($data: CfRoleInput!) {
    createCfRole(data: $data) {
      status
      msg
    }
  }
`;

export const UPDATE_CF_ROLE = gql`
  mutation UpdateCfRole($id: ID!, $data: CfRoleInput!) {
    updateCfRole(id: $id, data: $data) {
      status
      msg
    }
  }
`;

export const DELETE_CF_ROLE = gql`
  mutation DeleteCfRole($id: ID!) {
    deleteCfRole(id: $id) {
      status
      msg
    }
  }
`;

export const CREATE_SHOP_STAFF = gql`
  mutation CreateShopStaff($data: ShopStaffInput!) {
    createShopStaff(data: $data) {
      status
      msg
    }
  }
`;

export const UPDATE_SHOP_STAFF = gql`
  mutation UpdateShopStaff($id: ID!, $data: ShopStaffInput!) {
    updateShopStaff(id: $id, data: $data) {
      status
      msg
    }
  }
`;

export const ON_OFF_SHOP_STAFF = gql`
  mutation OnOffShopStaff($id: ID!, $isDeleted: Boolean!) {
    onOffShopStaff(id: $id, isDeleted: $isDeleted) {
      status
      msg
    }
  }
`;

export const DELETE_SHOP_STAFF = gql`
  mutation DeleteShopStaff($id: ID!) {
    deleteShopStaff(id: $id) {
      status
      msg
    }
  }
`;
